import { IconButton } from '../IconButton'
import { StyleFn } from '..'

export const Dialog: StyleFn = (theme) => {
  const { color, elevation, font, size, responsive } = theme
  const { root, _ghost } = IconButton(theme)

  return {
    root: {
      position: 'relative',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '28rem',
      overflowY: 'auto',
      // look
      borderRadius: '3px',
      color: color.getModalValues(color.text.primary),
      backgroundColor: color.getModalValues(color.background.primary),
      boxShadow: elevation.level5,
      textAlign: 'left',
      [`@media (max-width:${responsive.breakpoint.xs}px)`]: {
        margin: 0,
        maxWidth: '100%',
        height: '100%',
        maxHeight: '100% !important',
      },
    },
    _scrollDialog: {
      flex: '0 1 auto',
      maxHeight: `calc(100% - ${size.spacing[96]})`,
    },
    _scrollBody: {
      margin: `${size.spacing[48]} auto`,
    },
    wrapper: {
      height: '100%',
      outline: 0,
    },
    wrapper_scrollDialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    wrapper_scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    content: {
      fontSize: font.size.small,
      lineHeight: font.lineheight.small,
      padding: `${size.spacing[12]} ${size.spacing[24]}`,
      '& p': {
        margin: 0,
      },
      [`@media (max-width:${responsive.breakpoint.xs}px)`]: {
        flexGrow: 1,
      },
    },
    header: {
      fontSize: font.size['heading-6'],
      lineHeight: font.lineheight['heading-6'],
      padding: size.spacing[24],
      paddingRight: size.spacing[56],
      paddingBottom: size.spacing[4],
    },
    close: {
      ...root,
      ..._ghost,
      // increase specificity to avoid button override
      // see https://github.airbus.corp/Airbus/design-system/issues/2387
      '&$close': { position: 'absolute' },
      top: size.spacing[12],
      right: size.spacing[12],
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      padding: size.spacing[24],
      justifyContent: 'flex-end',
      '& > :not(:first-child)': {
        marginLeft: size.spacing[16],
      },
      [`@media (max-width:${responsive.breakpoint.xs}px)`]: {
        flexDirection: 'column',
        '& > *': {
          width: '100%',
        },
        '& > :not(:first-child)': {
          marginLeft: 0,
          marginTop: size.spacing[16],
        },
      },
    },
  }
}
